import { type SynopticCategory } from '@core/referential/synoptic-category.enum'
import { type SynopticType } from '@core/referential/synoptic-type.enum'
import { GetSynopticsResponseSchema } from '@shared/schema/synoptic.get-all.schema'
import { queryOptions } from '@tanstack/react-query'

import { apiFetch } from '@/lib/api-fetch'

type SynopticsFilters = {
  type?: SynopticType
  category?: SynopticCategory
  // Restreint aux synoptics sans site (templates, composants réutilisables) : ceux rattachés à un
  // site se gèrent depuis la vue technique de ce site.
  unlocated?: boolean
}

// Préfixe commun à toutes les variantes de filtres : les mutations invalident sur ce préfixe pour
// rafraîchir la liste quels que soient les filtres actifs.
export const SYNOPTICS_QUERY_KEY = ['synoptics'] as const

export function synopticsQuery(filters: SynopticsFilters = {}) {
  return queryOptions({
    queryKey: [...SYNOPTICS_QUERY_KEY, filters],
    async queryFn() {
      const searchParams = new URLSearchParams()

      if (filters.type) {
        searchParams.append('type', filters.type)
      }

      if (filters.category) {
        searchParams.append('category', filters.category)
      }

      if (filters.unlocated) {
        searchParams.append('unlocated', 'true')
      }

      const rawResponse = await apiFetch.get('synoptic', { searchParams })

      if (!rawResponse.ok) {
        throw new Error('Failed to fetch synoptics')
      }

      try {
        return await GetSynopticsResponseSchema.parseAsync(await rawResponse.json())
      } catch (error) {
        throw new Error('Failed to parse synoptics response', { cause: error })
      }
    },
  })
}
